import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isChromeBrowser } from "./utils/browserUtils";

// For Chrome, the service worker enables the PWA installation prompt.
if (isChromeBrowser() && navigator.serviceWorker) {
    navigator.serviceWorker.register("/no-op-service-worker.js");
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
